import { UserPlus } from 'lucide-react';
import ModalBtn from '../../molecules/modalButton/view';
import ThirdForm from '../thirdForm/view';
import { createThird } from '../../../usecases/thirds-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';

function NewThird({ id, initialData = {}, ...props }) {

    async function handleSubmit(data) {
        createThird(data).then((result) => {
            dispatchCustomEvent("modal-close-new-third", {});
            dispatchCustomEvent("modal-close-" + id, {});
            dispatchCustomEvent("loading-btn", {});

            if (result?.offline) {
                // Modo offline: auto-seleccionar el tercero temporal con datos del formulario
                const tempThird = {
                    id: result.id,
                    name: data.name,
                    identification: data.identification,
                    email: data.email,
                    phone: data.phone,
                    client: data.client,
                    provider: data.provider,
                    offline: true
                };
                dispatchCustomEvent("btn-thirds-add", { data: tempThird });
                dispatchCustomEvent("popup", {
                    message: `Tercero "${data.name}" guardado temporalmente. Se sincronizará cuando haya conexión.`,
                    type: "warning"
                });
            } else {
                dispatchCustomEvent("update-thirds", {});
                dispatchCustomEvent("popup", { message: "Tercero creado con éxito", type: "success" });
            }
        }).catch(err => {
            const msg = err.response?.data?.message || "Error al crear tercero";
            dispatchCustomEvent("popup", { message: msg, type: "error" });
            dispatchCustomEvent("loading-btn", {});
        });
    }

    return (
        <div {...props}>
            <ModalBtn
                id={id ? id : 'new-third'}
                title="Nuevo tercero"
                icon={<UserPlus size={20} />}
                type="primary"
                style={{ border: 'none', width: '100%', maxWidth: '850px', maxHeight: '90vh' }}
            >
                <ThirdForm
                    initialData={initialData}
                    onSubmit={handleSubmit}
                    loadingId="third-new"
                    title="Crear Nuevo Tercero"
                    submitLabel="Guardar Tercero"
                />
            </ModalBtn>
        </div>
    )
}

export default NewThird
